export default "__VITE_ASSET__DmrHWzD4__"